import { render, staticRenderFns } from "./ContentModeration.vue?vue&type=template&id=26f03898&"
import script from "./ContentModeration.vue?vue&type=script&lang=js&"
export * from "./ContentModeration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports